import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import NotificationHeaderAction from "./components/NotificationHeaderAction";
import NotificationToggleNavigation from "./components/NotificationToggleNavigation";
import Divider from "../../../Divider";

import {greyishBlue900} from "assets/jss/main";

import {SidebarContext} from "../../../../../../../../../../SidebarContext";

function NotificationHeader(props) {
    const {isMobile} = useContext(SidebarContext);

    return (
        <div>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                ...!isMobile && {
                    padding: '12px',
                }
            }}>
                {!isMobile ? (
                    <div style={{
                        fontSize: '14px',
                        color: greyishBlue900,
                        fontWeight: 600
                    }}>
                        <FormattedMessage id='sidebar.profil.notification.title' />
                    </div>
                ) : (
                    <div></div> /*empty div for keeping NotificationHeaderAction to the right*/
                )}
                <NotificationHeaderAction />
            </div>
            {!isMobile && <Divider />}
            <NotificationToggleNavigation />
        </div>
    );
}

export default NotificationHeader;
